import { gql, useQuery } from 'urql';
import { ElementTypeEnum } from '@entities/leadCollector/model/consts';

const GET_ELEMENTS_TEMPLATES_QUERY = gql`
  query GetElementsTemplates {
    getElementsTemplates {
      type
      elements {
        id
        name
        elementType
        properties
        order
        createdAt
        updatedAt
      }
    }
  }
`;

export interface ElementsTemplate {
  id: number;
  name: string;
  elementType: ElementTypeEnum;
  properties: unknown;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export interface ElementsTemplateGroupedByType {
  type: ElementTypeEnum;
  elements: ElementsTemplate[];
}

export interface GetElementsTemplatesResponse {
  getElementsTemplates: ElementsTemplateGroupedByType[];
}

export const useFetchElementsTemplates = () => {
  const [{ error, fetching, data }] = useQuery<GetElementsTemplatesResponse>({
    query: GET_ELEMENTS_TEMPLATES_QUERY,
    requestPolicy: 'network-only',
  });

  return {
    error,
    fetching,
    elementsTemplates: data?.getElementsTemplates || [],
  };
};
